/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateStandardConditionBoForm } from '../../models/update-standard-condition-bo-form';

export interface UpdateCondition$Params {

/**
 * Standard condition id
 */
  id: number;

/**
 * Svg id
 */
  svgId: number;
      body: UpdateStandardConditionBoForm
}

export function updateCondition(http: HttpClient, rootUrl: string, params: UpdateCondition$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateCondition.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('svgId', params.svgId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateCondition.PATH = '/svgs/{svgId}/standard-conditions/{id}';
